var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import DashboardFormTeamAthleteScore from './DashboardFormTeamAthleteScore';
import DashboardFormRound from './DashboardFormRound';
var DashboardForm = (function (_super) {
    __extends(DashboardForm, _super);
    function DashboardForm() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DashboardForm.prototype.render = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement(DashboardFormRound, null),
            React.createElement(DashboardFormTeamAthleteScore, null)));
    };
    return DashboardForm;
}(React.Component));
export default DashboardForm;



//////////////////
// WEBPACK FOOTER
// ./src/pages/WorkspaceEvent/PageDashboard/DashboardForm/index.tsx
// module id = 846
// module chunks = 0